import React from 'react';

function AndroidIcon() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 29" fill="currentColor" width="22" height="22">
			<path
				d="M38,21.67A2.2,2.2,0,0,1,36.45,21a2.13,2.13,0,0,1,0-3,2.16,2.16,0,1,1,3.08,3,2.22,2.22,0,0,1-1.54.63Zm-23.93,0a2.12,2.12,0,0,1-.83-.16A2.16,2.16,0,1,1,15.6,21a2.2,2.2,0,0,1-1.54.63ZM38.76,8.76,43.1,1.34a.87.87,0,0,0,.09-.67.88.88,0,0,0-.43-.53.89.89,0,0,0-.68-.09,1,1,0,0,0-.54.42L37.15,8A26.78,26.78,0,0,0,26,5.6,27.22,27.22,0,0,0,14.9,8L10.5.45a.78.78,0,0,0-.22-.26A1,1,0,0,0,10,0a.78.78,0,0,0-.34,0,1,1,0,0,0-.34.1A1,1,0,0,0,9,.34a.92.92,0,0,0-.16.31,1,1,0,0,0,0,.34,1.17,1.17,0,0,0,.11.33l4.33,7.42A25.33,25.33,0,0,0,0,29H52A25.21,25.21,0,0,0,38.76,8.76Z"/>
		</svg>
	);
}

export default AndroidIcon;